module.exports = __webpack_public_path__ + "static/media/RPR 2a3.bb07819a.jpg";